import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useReduxStore } from '../../redux/checkoutredux/ReduxCheckoutContext.tsx';

const CheckoutLayout = () => {
  const location = useLocation(); 
  const store = useReduxStore(); 
  const checkoutsteps = store.getState().checkoutsettings.checkoutSettings.checkout_steps;
  const reviewstep = store.getState().checkoutsettings.checkoutSettings.checkout_orderreview;

     /************ SELECTED ************** */
     const [shipordeliver, setShipOrDeliver] = useState(store.getState().selectedorderdata?.shipordeliverdata || '');



     useEffect(() => {
      const unsubscribe = store.subscribe(() => {
        setShipOrDeliver(store.getState().selectedorderdata.shipordeliverdata || '');
     
      });
    
      return () => {
        unsubscribe();
      };
    }, []);






  let shippingLink = null;
  if (checkoutsteps === 'select3' && shipordeliver === 'delivery') {
    shippingLink = (
      <>        
      <li className="nav-item">
      <span className="nav-link checkoutarrow">&#8594;</span>
      </li>
        <li className="nav-item">
          <Link to="/ips-shipping" className={`nav-link ips-checkout-shipping ${location.pathname === '/ips-shipping' ? 'active' : ''}`}>
            Shipping
          </Link>
        </li>

      </>
    );
  }

  let orderreviewLink = null;
  if (reviewstep === 'on') {
    orderreviewLink = (
      <>        
      <li className="nav-item">
      <span className="nav-link checkoutarrow">&#8594;</span>
      </li>
        <li className="nav-item">
          <Link to="/ips-orderreview" className={`nav-link ips-checkout-orderreview ${location.pathname === '/ips-orderreview' ? 'active' : ''}`}>
            Summary
          </Link>
        </li>

      </>
    );
  }


  return (
    <>
      <nav className="d-flex justify-content-start align-items-center">
        <ul className="nav">
          <li className="nav-item">
            <Link to="/" className={`nav-link ips-checkout-information ${location.pathname === '/' || location.pathname === '/informations' ? 'active' : ''}`}>
              Information
            </Link>
          </li>

          {shippingLink}
          <li className="nav-item">
            <span className="nav-link checkoutarrow">&#8594;</span>
          </li>
          <li className="nav-item">
            <Link to="/ips-payment" className={`nav-link ips-checkout-payment ${location.pathname === '/ips-payment' ? 'active' : ''}`}>
              Payment
            </Link>
          </li>
          {orderreviewLink}
        </ul>
      </nav>
      <Outlet />
    </>
  );
};

export default CheckoutLayout;